import React, { Component, Fragment } from 'react'
import { withRouteData } from 'react-static'

import Template from './TemplateLandingPage'
import NewMenu from '../../../blocks/Menu/NewMenu'
import Hero from '../../../blocks/LandingPageBlocks/Hero'
import RepresentativeSections from '../../../blocks/LandingPageBlocks/RepresentativeSections'

export default withRouteData(({ pageData }) => {

    const keywords = ['representante', 'representações'];

    const formatText = (text) => {
        let formattedText = [text];
        let keywordFound = false;

        keywords.forEach((keyword) => {
            const re = new RegExp(`(${keyword})`, 'gi');
            formattedText = formattedText.reduce((acc, chunk) => {
                if (typeof chunk === 'string') {
                    const splitText = chunk.split(re);
                    splitText.forEach(part => {
                        if (re.test(part)) {
                            keywordFound = true;
                        }
                    });
                    return acc.concat(splitText.map((part, index) =>
                        re.test(part) ? <strong key={index}>{part}</strong> : part
                    ));
                } else {
                    return acc.concat(chunk);
                }
            }, []);
        });

        if (!keywordFound) {
            return <strong>{text}</strong>;
        }

        return formattedText;
    }

    let heading1 = formatText(pageData.heading1);
    let pageDescription = pageData.paragraph;

    return (
        <Fragment>
            <NewMenu
                whiteBackground
            />
            <Template representative>
                <Hero whiteBg title={heading1} description={pageDescription} />
                <RepresentativeSections />
            </Template>
        </Fragment>
    )
}

)



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/ConquerMarketsv2.jsx